export const COMPONENT_NAME = "admin-config-requisites-form-bank";
